import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import {Container, Card, Button, Spinner, Alert, Table} from "react-bootstrap";
import { useAuth } from "./AuthContext";
import {SERVER_BASE_URL} from "../Constants";

export default function CompetitionDetails() {
    const { competition_id } = useParams();
    const [competition, setCompetition] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [workouts, setWorkouts] = useState([]);

    const { isAdmin } = useAuth();

    useEffect(() => {
        const fetchCompetition = async () => {
            try {
                const response = await axios.get(SERVER_BASE_URL + `api/competitions/${competition_id}`); // Replace with actual API endpoint
                console.log(response);
                setCompetition(response.data);
            } catch (err) {
                console.error("Error fetching competition:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        const fetchWorkouts = async () => {
            try {
                const response = await axios.get(SERVER_BASE_URL + `api/workouts/by-competition/${competition_id}`);
                console.log(response);
                setWorkouts(response.data);
            } catch (err) {
                console.error("Error fetching workouts:", err);
            }
        };

        fetchWorkouts();
        fetchCompetition();
    }, [competition_id]);

    return (
        <Container className="mt-4">
            {error && <Alert variant="danger">Error: {error}</Alert>}
            {loading ? (
                <div className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            ) : competition ? (
                <Card className="shadow-lg p-4">
                    <Card.Body>
                        <Card.Title className="text-center mb-4">{competition.competition_name}</Card.Title>
                        <Card.Text><strong>Description:</strong> {competition.description}</Card.Text>
                        <Card.Text><strong>Participation Type:</strong> {competition.participation_type}s</Card.Text>
                        <Card.Text><strong>Start Date:</strong> {new Date(competition.start_date).toLocaleString()}</Card.Text>
                        <Card.Text><strong>End Date:</strong> {new Date(competition.end_date).toLocaleString()}</Card.Text>
                        <Card.Title className="text-left mb-4">Workouts:</Card.Title>
                        <Table striped bordered hover>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Description</th>
                                <th>Scoring Type</th>
                                <th>Tiebreaker Type</th>
                            </tr>
                            </thead>
                            <tbody>
                            {workouts.length > 0 ? workouts.map((workout, index) => (
                                <tr key={index}>
                                    <td>{workout.workout_name}</td>
                                    <td style={{ whiteSpace: "pre-line" }}>{workout.workout_description}</td>
                                    <td>{workout.scoring_type}</td>
                                    <td>{workout.tie_breaker_type}</td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="4" className="text-center">No workouts found</td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                        <div className="text-center">
                            {isAdmin() ? (
                                <>
                                <Button variant="outline-primary" href={`/edit-competition/${competition.competition_id}`} className="me-2">Edit Competition</Button>
                                <Button variant="outline-primary" href={`/workouts/create?competition_id=${competition.competition_id}&competition_name=${encodeURIComponent(competition.competition_name)}`} className="me-2">Create Workout</Button>
                                </>
                            ) : (<></>)
                            }
                            <Button variant="outline-primary" href="/competitions">Back</Button>
                        </div>

                    </Card.Body>
                </Card>
            ) : (
                <Alert variant="warning">Competition not found.</Alert>
            )}
        </Container>
    );
}
